import { Injectable } from '@angular/core';
import { ModalController, ToastController, LoadingController, AlertController, NavController, ActionSheetController, Platform } from '@ionic/angular';
import swal from 'sweetalert';

@Injectable({
  providedIn: 'root'
})
export class IonicComponentesService {

  isLoading;
  constructor(
    private toastCtrl: ToastController,
    private loadCtrl: LoadingController,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private platform: Platform,
    private actSheet: ActionSheetController,
    public modalController: ModalController) { }

  async presentloandingC(){

   this.loadCtrl.create({
       spinner: "crescent",
       message: 'Porfavor espere...',
       translucent: true,
       cssClass: 'activity-detail-loading'
    }).then((a) => {
      a.present();
    });
  }

  async dismissLoading() {
    setTimeout(() => {
      this.loadCtrl.dismiss().then((response) => {
        console.log('Loader closed!', response);
      }).catch((err) => {
        console.log('Error occured : ', err);
      });
    }, 600);
  }

  async presentToast(a){
    const toast = await this.toastCtrl.create({
       message: a,
       duration: 1500,
       position: 'top'
     });

     toast.present();
  }

  async presentAlert(a) {
    const alert = await this.alertCtrl.create({
      header: a,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Cerrar',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Intenta de nuevo',
          handler: () => {}
        }
      ]
    });

    await alert.present();
  }

  mensaje(sms, icon){
    swal({
     title: sms,
     icon: icon
    });
  }

}
